import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import RowDisplay from '../../common/RowDisplay';
import { ProfileViewDetail } from '../../common/ProfileView/ProfileViewDetail';
import { ProfileViewRow } from '../../common/ProfileView/ProfileViewRow';
import { INSURANCE_STATUSES } from './constants';
import { dateToEpoch, epochToDate } from '../../utils/epoch';
import { EditSocialInsurance } from './EditSocialInsurance';
import { InsuranceStatusIndicator } from './InsuranceStatusIndicator';
import { RejectionToolTip } from './RejectionToolTip';
export var SocialInsuranceProfileView = function SocialInsuranceProfileView(_ref) {
  var _insurance$plan$name, _insurance$plan;
  var goToEnrollmentWorkflow = _ref.goToEnrollmentWorkflow,
    insurance = _ref.insurance,
    lastUpdate = _ref.lastUpdate,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate;
  var hasEnrollmentWQ = useFeatureFlag('enrollment-wq');
  var planName = (_insurance$plan$name = insurance === null || insurance === void 0 || (_insurance$plan = insurance.plan) === null || _insurance$plan === void 0 ? void 0 : _insurance$plan.name) !== null && _insurance$plan$name !== void 0 ? _insurance$plan$name : '';
  var startDate = insurance === null || insurance === void 0 ? void 0 : insurance.enrolled_at;
  var endDate = insurance === null || insurance === void 0 ? void 0 : insurance.expired_at;
  var insuranceStatus = insurance === null || insurance === void 0 ? void 0 : insurance.insurance_status;
  var convertDateStringToDisplayValue = function convertDateStringToDisplayValue(dateString) {
    return dateString ? epochToDate(dateToEpoch(dateString)) : '--';
  };
  var columnWidth = hasEnrollmentWQ ? 3 : 4;
  return /*#__PURE__*/React.createElement("div", {
    className: "payments-insurance-information",
    "data-testid": "social-insurance-profile-view"
  }, /*#__PURE__*/React.createElement(RowDisplay, {
    editSection: /*#__PURE__*/React.createElement(EditSocialInsurance, {
      goToEnrollmentWorkflow: goToEnrollmentWorkflow,
      insuranceId: insurance.id
    }),
    label: "Social Care Coverage",
    lastUpdate: lastUpdate,
    showLastUpdate: shouldShowLastUpdate,
    hideEdit: hasEnrollmentWQ && insuranceStatus === INSURANCE_STATUSES.not_enrolled,
    itemId: insurance.id
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow"
  }, /*#__PURE__*/React.createElement(ProfileViewRow, null, /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "Plan Name",
    labelTestId: "sccPlanNameKey",
    value: planName,
    valueTestId: "sccPlanNameValue",
    columnWidth: columnWidth
  }), /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "Start Date",
    labelTestId: "sccPlanStartDateKey",
    value: convertDateStringToDisplayValue(startDate),
    valueTestId: "sccPlanStartDateValue",
    columnWidth: columnWidth
  }), /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "End Date",
    labelTestId: "sccPlanEndDateKey",
    value: convertDateStringToDisplayValue(endDate),
    valueTestId: "sccPlanEndDateValue",
    columnWidth: columnWidth
  }), hasEnrollmentWQ && /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: "Status",
    labelTestId: "sccPlanEnrollStatusKey",
    columnWidth: columnWidth
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(RejectionToolTip, {
    insurance: insurance
  }), /*#__PURE__*/React.createElement(InsuranceStatusIndicator, {
    status: insuranceStatus
  })))))));
};
SocialInsuranceProfileView.propTypes = {
  goToEnrollmentWorkflow: PropTypes.func.isRequired,
  insurance: PropTypes.object,
  lastUpdate: PropTypes.object,
  shouldShowLastUpdate: PropTypes.bool
};
SocialInsuranceProfileView.defaultProps = {
  insurance: {},
  lastUpdate: {
    recently_updated_at: null,
    recently_updated_by_name: null,
    versions: null
  },
  shouldShowLastUpdate: false
};
//# sourceMappingURL=SocialInsuranceProfileView.js.map